module.exports = __webpack_public_path__ + "static/img/face.3cf2f88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/face.jpg
// module id = y+PD
// module chunks = 0